export default __webpack_public_path__ + "static/media/class.b291dfcd.jpg";